// ========================================
// EVENTS GALLERY SECTION - WEDDING EVENT
// ========================================

import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { FiZoomIn } from 'react-icons/fi';
import '../../../assets/css/customer/events/EventGallery.css';

const EventGallery = () => {
  // Gallery images data - Replace with your actual images
  const galleryImages = [
    {
      id: 1,
      src: 'https://i.pinimg.com/736x/fd/a3/fe/fda3fecc330fc4f2b9edc07beec8a40f.jpg',
      alt: 'Wedding Couple 1'
    },
    {
      id: 2,
      src: 'https://i.pinimg.com/1200x/a6/97/54/a69754109b5b9d11f45daa6f4173cfb4.jpg',
      alt: 'Wedding Couple 2'
    },
    {
      id: 3,
      src: 'https://images.unsplash.com/photo-1591604466107-ec97de577aff?w=500&h=500&fit=crop',
      alt: 'Wedding Couple 3'
    },
    {
      id: 4,
      src: 'https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=500&h=500&fit=crop',
      alt: 'Wedding Couple 4'
    },
    {
      id: 5,
      src: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=500&h=500&fit=crop',
      alt: 'Wedding Couple 5'
    },
    {
      id: 6,
      src: 'https://images.unsplash.com/photo-1537633552985-df8429e8048b?w=500&h=500&fit=crop',
      alt: 'Wedding Couple 6'
    }
  ];

  // Handle image click - You can add lightbox functionality here
  const handleImageClick = (image) => {
    console.log('Image clicked:', image);
    // TODO: Add lightbox or modal functionality
    // Example: setSelectedImage(image);
  };

  return (
    <section className="events-gallery-section">
      <Container>
        {/* Section Header */}
        <div className="gallery-header">
          <p className="gallery-label">Unforgettable Events</p>
          <h2 className="gallery-heading">
            Capturing Love and Celebration<br />
            in Visual Showcase
          </h2>
        </div>

        {/* Gallery Grid */}
        <div className="gallery-grid">
          {galleryImages.map((image) => (
            <div 
              key={image.id} 
              className="gallery-item"
              onClick={() => handleImageClick(image)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter') handleImageClick(image);
              }}
            >
              <img 
                src={image.src} 
                alt={image.alt}
                className="gallery-image"
                loading="lazy"
              />
              <div className="gallery-overlay">
                <div className="zoom-icon">
                  <FiZoomIn />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Decorative Line */}
        <div className="gallery-decorative-line"></div>
      </Container>
    </section>
  );
};

export default EventGallery;